import { CheckCircle } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface RemoveEventDialogProps {
  open: boolean;
  handleClose: () => void;
}

const AvailabilitySubmittedDialog: React.FC<RemoveEventDialogProps> = ({
  open,
  handleClose
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="availability-submitted-dialog-title"
      aria-describedby="availability-submitted-dialog-description"
    >
      <DialogTitle id="availability-submitted-dialog-title">
        {t("ROOSTER.PUBLIC-APP.AVAILABILITY_SAVED", {
          defaultValue: "Availability Saved"
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="availability-submitted-dialog-description"
          fontSize={15}
        >
          {t("ROOSTER.PUBLIC-APP.AVAILABILITY_SAVED_MESSAGE", {
            defaultValue:
              "Your availability has been saved and sent for review."
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          onClick={() => {
            handleClose();
          }}
          color="primary"
        >
          <CheckCircle /> &nbsp;{" "}
          {t("ROOSTER.COMMON.OK", {
            defaultValue: "OK"
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AvailabilitySubmittedDialog;
